export default __webpack_public_path__ + "static/media/Iconly-Bold-Filter.d3a16eeb.svg";